import React, { FC, useState } from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface Props {
  message: String;
  open: boolean;
  severity: "success" | "info" | "warning" | "error" | undefined;
  onClose?: any;
}

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="standard" {...props} />;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alert: {
      height: 100,
      alignItems: "center"


    },
    snackbar: {
      [theme.breakpoints.down('md')]: {
        bottom: 280,
      },
      [theme.breakpoints.up('md')]: {
        bottom: 220,
      },

    },
  }),
);

const SnackBarAlert: FC<Props> = (p) => {
  const classes = useStyles();
  const [open, setOpen] = useState(p.open);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Snackbar className={classes.snackbar}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }} open={open} autoHideDuration={6000} onClose={p.onClose ?? handleClose}>
      <Alert className={classes.alert} onClose={p.onClose ?? handleClose} severity={p.severity}>
        {p.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBarAlert;
